export function stepSlider() {
    $(".points .slider").slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        mobileFirst: true,
        prevArrow: $(".points .common-slider-controls .prev-arrow"),
        nextArrow: $(".points .common-slider-controls .next-arrow"),
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 319,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/step-slider.js